import {register} from '../locale';

register('de-DE', {
  'Action.countDown': '${timeLeft} warten',
  'Alert.info': 'Systeminformationen',
  'asc': 'Aufsteigend',
  'cancel': 'Abbrechen',
  'Card.dragTip': 'Obere Schaltfläche zum Sortieren ziehen',
  'Card.toggleDrag': 'Zum Sortieren umschalten',
  'City.street': 'Straße eingeben',
  'clear': 'Löschen',
  'ColorPicker.placeholder': 'Farbe auswählen',
  'Combo.add': 'Neu',
  'Combo.dragDropSort': 'Zum Sortieren ziehen',
  'Combo.invalidData': 'Ungültige Daten, bitte entfernen',
  'Combo.maxLength': 'Maximale Anzahl ist {{MaxLength}}}. Löschen Sie einige Elemente.',
  'Combo.minLength': 'Mindestens {{minLength}} erfoderlich. Fügen Sie weitere hinzu.',
  'Combo.type': 'Typ',
  'confirm': 'Bestätigen',
  'Copyable.tip': 'Kopieren',
  'CRUD.exportCSV': 'In CSV exportieren',
  'CRUD.exportExcel': 'In Excel exportieren',
  'CRUD.fetchFailed': 'Fehler beim Abrufen',
  'CRUD.filter': 'Filtern',
  'CRUD.selected': 'Ausgewählte Elemente: ',
  'CRUD.invalidArray': '"data.items" muss ein Array sein',
  'CRUD.invalidData': '"data" ist leer',
  'CRUD.loadMore': 'Weitere laden',
  'CRUD.perPage': 'Pro Seite',
  'CRUD.stat': '{{page}} von {{lastPage}} insgesamt: {{total}}.',
  'CRUD.paginationGoText': 'Wechseln zu',
  'CRUD.paginationPageText': 'Seite',
  'PaginationWrapper.placeholder': 'Textkörper konfigurieren',
  'Date.daysago': 'Vor {{days}} Tag(en)',
  'Date.dayslater': '{{days}} Tag(e) später',
  'Date.endOfMonth': 'Letzter Tag des Monats',
  'Date.endOfLastMonth': 'Letzer Tag des letzten Monats',
  'Date.endOfWeek': 'Samstag',
  'Date.hoursago': 'Vor {{hours}} Stunde(n)',
  'Date.hourslater': '{{hours}} Stunde(n) später',
  'Date.invalid': 'Ungültiges Datum',
  'Date.monday': 'Montag',
  'Date.monthsago': 'Vor {{months}} Monat(en)',
  'Date.monthslater': '{{months}} Monat(e) später',
  'Date.now': 'Jetzt',
  'Date.placeholder': 'Datum wählen',
  'Date.quartersago': 'Vor {{quarters}} Quartal(en)',
  'Date.quarterslater': '{{quarters}} Quartal(e) später',
  'Date.startOfLastMonth': 'Erster Tag des letzten Monats',
  'Date.startOfLastQuarter': 'Erster Tag des letzten Quartals',
  'Date.startOfMonth': 'Erster Tag des Monats',
  'Date.startOfQuarter': 'Erster Tag des Quartals',
  'Date.today': 'Heute',
  'Date.tomorrow': 'Morgen',
  'Date.weeksago': 'vor {{weeks}} Woche',
  'Date.weekslater': '{{weeks}} Wochen später',
  'Date.yesterday': 'Gestern',
  'dateformat.year': 'YYYY',
  'DateRange.1daysago': 'Vor 1 Tag',
  'DateRange.7daysago': 'Vor 7 Tagen',
  'DateRange.30daysago': 'Vor 30 Tagen',
  'DateRange.90daysago': 'Vor 90 Tagen',
  'DateRange.lastMonth': 'Letzer Monat',
  'DateRange.lastWeek': 'Letzte Woche',
  'DateRange.lastQuarter': 'Letztes Quartal',
  'DateRange.placeholder': 'Datumsbereich wählen',
  'DateRange.thisWeek': 'Diese Woche',
  'DateRange.thisMonth': 'Diesen Monat',
  'DateRange.thisQuarter': 'Dieses Quartal',
  'DateRange.valueConcat': ' bis ',
  'DateTime.placeholder': 'Datum auswählen',
  'delete': 'Löschen',
  'deleteConfirm': 'Möchten Sie wirklich löschen?',
  'deleteFailed': 'Fehler beim Löschen',
  'desc': 'Absteigend',
  'Dialog.close': 'Schließen',
  'fetchFailed': 'Fehler beim Abrufen der API',
  'File.continueAdd': 'Hinuzufügen fortsetzen',
  'File.dragDrop': 'Dateien per Drag & Drop hier ablegen',
  'File.errorRetry': 'Fehler beim Hochladen der Datei, bitte versuchen Sie es erneut.',
  'File.failed': 'Fehlerhafte Dateien',
  'File.invalidType': '{{files}} entspricht nicht Typ `{{accept}}`',
  'File.maxSize': '{{filename}} überschreitet die maximale Größe von {{maxsize}} (in Byte)',
  'File.pause': 'Hochladen anhalten',
  'File.repick': 'Erneut suswählen',
  'File.result': 'Erfolgreich hochgeladene Dateien: {{uploaded}}, nicht hochgeladene Dateien: {{failed}}',
  'File.retry': 'Wiederholen',
  'File.start': 'Hochladen beginnen',
  'File.upload': 'Hochladen',
  'File.uploadFailed': 'Zurückgegebene Daten der Upload-API sind leer',
  'File.uploading': 'Wird hochgeladen...',
  'Form.loadOptionsFailed': 'Optionen wurden auf folgendem Grund nicht geladen: {{reason}}',
  'Form.submit': 'Absenden',
  'Form.title': 'Formular',
  'Form.unique': 'Aktueller Wert ist nicht eindeutig',
  'Form.validateFailed': 'Fehler bei der Überprüfung der Formulareingabe',
  'Image.configError': 'Es können nur eine Beschneidung oder mehrere festgelegt werden',
  'Image.crop': 'Bild beschneiden',
  'Image.dragDrop': 'Bilder per Drag & Drop hier ablegen',
  'Image.height': 'Höhe: {{height}} Pixel',
  'Image.limitMax': 'Minimale Bildgröße ist {{info}}',
  'Image.limitMin': 'Maximale Bildgröße ist {{info}}',
  'Image.limitRatio': 'Laden Sie das Bild mit dem Seitenverhältnis {{ration}} hoch',
  'Image.pasteTip': 'Sie können das Bild aus der Zwischenablage einfügen',
  'Image.placeholder': 'Klicken Sie, um das Bild einzufügen, oder ziehen Sie es in diesen Bereich.',
  'Image.size': 'size: ({{width}} Pixel x {{height}} Pixel)',
  'Image.sizeNotEqual': 'Das ausgwählte Bild entspricht nicht den Größenanforderungen {{info}}',
  'Image.width': 'Weite: {{width}} Pixel',
  'Image.zoomIn': 'Vergrößern',
  'Log.mustHaveSource': 'Quelle muss in der Konfiguration vorhanden sein',
  'link': 'Link',
  'loading': 'Wird geladen...',
  'LocationPicker.placeholder': 'Wählen Sie einen Ort',
  'Month.placeholder': 'Wählen Sie einen Monat',
  'Nav.sourceError': 'Fehler beim Abrufen des Links',
  'networkError': 'Fehler beim Netzwerkzugriff oder fehlende CORS-Konfiguration',
  'noResult': 'Keine Ergebnisse',
  'NumberInput.placeholder': 'Geben Sie eine Zahl ein',
  'Options.addPlaceholder': 'Geben Sie einen Namen ein',
  'Options.deleteAPI': '"deleteAPI" erforderlich',
  'Options.editLabel': 'Bearbeiten {{label}}',
  'Options.label': 'Option',
  'placeholder.empty': '<Empty>',
  'placeholder.enter': 'Eingabe',
  'placeholder.noData': 'Keine Daten',
  'placeholder.noOption': 'Keine Option',
  'placeholder.selectData': 'Daten auswählen',
  'Quarter.placeholder': 'Quartal auswählen',
  'Repeat.pre': 'Pro',
  'reset': 'Zurücksetzen',
  'saveFailed': 'Fehler beim Speichern',
  'saveSuccess': 'Erfolgreich gespeichert',
  'search': 'Suchen',
  'searchResult': 'Suchergebnis',
  'Select.checkAll': 'Alle markieren',
  'Select.clear': 'Löschen',
  'Select.clearAll': 'Alle löschen',
  'Select.createLabel': 'Neue Option',
  'Select.placeholder': 'Auswählen',
  'Select.searchPromptText': 'Eingeben zum Suchen',
  'sort': 'Sortieren',
  'SubForm.button': 'Configurieren',
  'SubForm.editDetail': 'Details bearbeiten',
  'Table.addRow': 'Zeile hinzufügen',
  'Table.columnsVisibility': 'Klicken, um die Sichtbarkeit der Spalten zu steuern',
  'Table.deleteRow': 'Aktuele Zeile löschen',
  'Table.discard': 'Verwerfen',
  'Table.dragTip': 'Schaltfläche links zum Sortieren ziehen',
  'Table.editing': 'Sie müssen die Bearbeitung beenden.',
  'Table.editRow': 'Aktuelle Zeile bearbeiten',
  'Table.modified': 'Es wurden {{modified}} Datensätze geändert, Sie können:',
  'Table.moved': 'Bei {{moved}} Datensätzen wurde die Reihenfolge geändert, Sie können:',
  'Table.operation': 'Vorgang',
  'Table.playload': 'Nutzlast muss vorhanden sein',
  'Table.startSort': 'Klicken, um Sortierung zu starten',
  'Table.valueField': 'valueField muss vorhanden sein',
  'Tag.placeholder': 'Noch kein Tag',
  'Tag.tip': 'Kürzlich verwendetes Tag',
  'Text.add': 'Neu {{label}}',
  'Time.placeholder': 'Zeit auswählen',
  'Transfer.configError': 'Konfigurationsfehler',
  'Transfer.refreshIcon': 'Zum Aktualisieren klicken',
  'Transfer.searchKeyword': 'Stichwörter eingeben',
  'Transfer.selectd': 'Ausgewählt',
  'Transfer.selectFromLeft': 'Von links auswählen',
  'Tree.addChild': 'Untergeordnetes Element hinzufügen',
  'Tree.addRoot': 'Stammknoten hinzufügen',
  'Tree.editNode': 'Diesen Knoten bearbeiten',
  'Tree.removeNode': 'Diesen Knoten entfernen',
  'Tree.root': 'Stamm',
  'validate.equals': 'Wert muss $1 sein',
  'validate.equalsField': 'Wert muss $1 sein',
  'validate.gt': 'Geben Sie einen Wert ein, der größer ist als $1',
  'validate.isAlpha': 'Geben Sie Buchstaben ein',
  'validate.isAlphanumeric': 'Geben Sie Buchstaben oder Zahlen ein.',
  'validate.isEmail': 'E-Mail-Format ist falsch',
  'validate.isFloat': 'Geben Sie einen Gleitkommawert ein',
  'validate.isId': 'Ungültige ID-Kartennummer',
  'validate.isInt': 'Geben Sie eine ganze Zahl ein',
  'validate.isJson': 'Ungültiges JSON-Format',
  'validate.isLength': 'Vergewissern Sie sich, dass die Länge des Inhalts $1 ist',
  'validate.isNumeric': 'Geben Sie eine Nummer ein',
  'validate.isPhoneNumber': 'Ungültige Telefonnummer',
  'validate.isRequired': 'Dies ist erforderlich',
  'validate.isTelNumber': 'Ungültige Telefonnummer',
  'validate.isUrl': 'Falsches URL-Format',
  'validate.isUrlPath': 'Sie können nur Buchstaben, Zahlen, "-" und "_" eingeben.',
  'validate.isWords': 'Geben Sie ein Wort ein',
  'validate.isZipcode': 'Ungültige Postleitzahl',
  'validate.lt': 'Geben Sie einen Wert ein, der kleiner ist als $1',
  'validate.matchRegexp': 'Das Format ist nicht korrekt. Geben Sie den Inhalt mit der Regel `${1| raw}` ein.',
  'validate.maximum': 'Der Eingabewert überschreitet den maximalen Wert von $1.',
  'validate.maxLength': 'Kontrollieren Sie die Länge des Inhalts. Geben Sie nicht mehr als $1 Buchstaben ein.',
  'validate.minimum': 'Der Eingabewert ist kleiner als der Mindestwert von $1.',
  'validate.minLength': 'Geben Sie weitere Zeichen ein, mindestens $1.',
  'validate.notEmptyString': 'Geben Sie nicht nur Leerzeichen ein.',
  'validateFailed': 'Fehler bei der Überprüfung,',
  'Wizard.configError': 'Konfigurationsfehler',
  'Wizard.finish': 'Ende',
  'Wizard.next': 'Weiter',
  'Wizard.prev': 'Zurück',
  'Wizard.saveAndNext': 'Speichern & Weiter',
  'year-to-year': '{{from}} - {{to}}',
  'Year.placeholder': 'Wählen Sie ein Jahr'
});
